import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token, USD_MOCK_TOKEN } from '@/domain/types/Token'
import { CopyableContentTooltip } from '@/ui/molecules/copyable-content-tooltip/CopyableContentTooltip'

export interface UsdAmountTooltipProps {
  amount: NormalizedNumber
  token: Token
  style: 'compact' | 'auto'
  className?: string
}

export function UsdAmountTooltip({ amount, token, style, className }: UsdAmountTooltipProps) {
  return (
    <CopyableContentTooltip
      className={className}
      content={[
        {
          label: USD_MOCK_TOKEN.formatUSD(token.toUSD(amount)),
          textToCopy: token.toUSD(amount).toFixed(2),
        },
      ]}
    >
      {token.formatUSD(amount, { compact: style === 'compact' })}
    </CopyableContentTooltip>
  )
}
